<template>
  <div class="DecisionServices">
    <div class="header">
      <div class="sysName">
        <img src="@/assets/images/service/service-icon.png" alt="" />
        <div class="title">{{ sysname }}</div>
      </div>
      <div class="nav-control">
        <div
          class="item"
          :class="{ active: routePath === `/${company}/liveData` }"
          @click="navigateTo('liveData')"
        >
          实况数据
        </div>
        <div
          class="item"
          :class="{ active: routePath === `/${company}/statisticalReport` }"
          @click="navigateTo('statisticalReport')"
        >
          统计报表
        </div>
      </div>
      <div class="right">
        <div class="tip">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <div class="item">常用链接</div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="https://weibo.com/nhqxt"
                >南海天气微博官方网站</el-dropdown-item
              >
              <el-dropdown-item command="https://www.fs121.com/mainnanhai"
                >南海天气官方网站</el-dropdown-item
              >
              <el-dropdown-item command="https://www.fs121.com/"
                >佛山天气官方网站</el-dropdown-item
              >
              <el-dropdown-item command="http://gd.cma.gov.cn/"
                >广东省气象局官方网站</el-dropdown-item
              >
              <el-dropdown-item command="http://www.nmc.cn/"
                >中央气象台官方网站</el-dropdown-item
              >
              <el-dropdown-item command="http://www.qxkp.net/"
                >中国气象科普网</el-dropdown-item
              >
              <el-dropdown-item command="https://msks.qxcbs.com/index.html"
                >气象科学知识服务平台</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="dateTimes">
          <div class="times">{{ times }}</div>
          <div class="date">{{ date }}</div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      times: "",
      date: "",
      routePath: "/liveData",
      company: "",
      sysname: "佛山市行业气象决策服务",
    };
  },
  mounted() {
    this.company = this.$route.params.company;
    const { unit } = JSON.parse(localStorage.getItem(this.company));
    this.sysname = unit.jcsysname;
    this.routePath = this.$route.path;
    this.date = this.$moment(new Date()).format("yyyy.MM.DD");
    // 在组件挂载时启动定时器
    this.timer = setInterval(() => {
      this.times = this.$moment(new Date()).format("HH:mm:ss");
    }, 1000);
  },
  methods: {
    navigateTo(routeName) {
      // 使用 $router.push 跳转到指定路由
      this.$router.push({ path: routeName });
    },
    handleCommand(command) {
      window.open(command, "_blank");
    },
  },
  watch: {
    // 监听路由路径的变化
    $route(to) {
      this.routePath = to.path;
      console.log("to.path", to.path);
    },
  },
  beforeDestroy() {
    // 在组件销毁前清除定时器，避免内存泄漏
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
.DecisionServices {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .header {
    height: 7.7778vh;
    background: url("../../assets/images/service/service-header.png");
    background-size: 100% 100%;
    position: relative;
    .sysName {
      width: 25.08vw;
      height: 6.2593vh;
      position: absolute;
      left: 2%;
      display: flex;
      align-items: center;
      gap: 0.42vw;
      img {
        width: 1.4vw;
        height: 1.56vw;
        object-fit: contain;
      }
      .title {
        font-size: 1.65vw;
        color: #fff;
        font-weight: bold;
        text-shadow: 1px 6px 2px rgba(0, 0, 0, 0.4);
        transform: skew(-4deg, 0deg);
        -webkit-transform: skew(-4deg, 0deg);
        -moz-transform: skew(-4deg, 0deg);
        -ms-transform: skew(-4deg, 0deg);
      }
    }
    .nav-control {
      position: absolute;
      top: 1.2963vh;
      left: 30%;
      display: flex;
      align-items: center;
      gap: 0.1vw;
      font-weight: 600;
      font-size: 0.83vw;
      color: #0050af;
      .item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../assets/images/service/未选@2x.png");
        background-size: 100% 100%;
        width: 8.08vw;
        height: 6.2593vh;
      }
      .active {
        color: #fff;
        background: url("../../assets/images/service/已选@2x.png");
        background-size: 100% 100%;
      }
    }
    .right {
      position: absolute;
      top: 1.2963vh;
      right: 1.04vw;
      display: flex;
      align-items: center;
      gap: 1.42vw;
      .tip {
        display: flex;
        align-items: center;
        .item {
          font-weight: 600;
          font-size: 0.83vw;
          color: #0050af;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          background: url("../../assets/images/service/未选@2x.png");
          background-size: 100% 100%;
          width: 8.08vw;
          height: 6.2593vh;
        }
      }
      .dateTimes {
        display: flex;
        flex-direction: column;
        .times {
          font-family: DingTalk, DingTalk;
          font-weight: normal;
          font-size: 1.46vw;
          color: #333333;
        }
        .date {
          font-family:
            PingFangSC,
            PingFang SC;
          font-weight: 400;
          font-size: 0.83vw;
          color: #333333;
        }
      }
    }
  }
}
</style>
